var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',{staticClass:"grey lighten-3"},[_c('v-sheet',{staticClass:"wrap",attrs:{"rounded":"xl"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }